<template>
  <div class="bd3test">
    <bg-intro :bg="bg" class="bg-wrapper"></bg-intro>
    <div class="intro-section">
      <div class="content_wrapper">
        <h3>北斗三号短报文RDSS测试软件</h3>
        <p>
          北斗三号短报文RDSS测试软件兼容北斗一号4.0协议，北斗二号2.1协议，北斗三号协议。支持使用串口和网口方式连接短报文终端进行测试，支持车载，数传，船载，指挥机等各类产品。
        </p>
        <p>
          软件设计的功能有：IC卡查询，功率查询，终端自检、指挥机功能（下属卡检测，监听，通播，兼收）、短报文通信（自发自收，互相收发，成功率测试等）、RNSS信息查收（GGA、GSV、GLL、GSA、RMC、ZDA，天空图，卫星列表查看等）、透传调试（预设指令输入，串口数据监听、串口数据发送、常用指令发送等）。
        </p>

        <product title="适用设备" :productData="productData"></product>
      </div>
    </div>

    <div class="doc-section">
      <div class="content_wrapper">
        <h3>功能介绍</h3>
        <div class="doc-wrapper">
          <div
            class="doc-item space-between"
            v-for="item in introData"
            :key="item.id"
            :class="item.id % 2 == 0 ? 'reverse' : ''"
          >
            <div class="left-item" :class="item.id % 2 == 0 ? '' : 'right90'">
              <img :src="item.introImg" :alt="item.title" />
            </div>

            <div class="right-item">
              <div class="right-head flex-start">
                <img :src="item.iconImg" :alt="item.title" />
                <h4>{{ item.title }}</h4>
              </div>
              <div class="intro">
                <p v-for="introItem in item.introContent" :key="introItem">{{ introItem }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="download-section content_wrapper">
      <a
        class="item"
        target="_blank"
        href="https://back.openc.beidousdk.com/api/console/files/material/other/bd3-test-software.zip"
        download
      >
        <img src="../../assets/pcbd3/bd3test/RDSS测试软件logo.png" alt="" />
        <span>软件下载</span>
      </a>
      <a
        class="item"
        target="_blank"
        href="https://back.openc.beidousdk.com/api/console/files/material/other/bd3-test-software-instruction-manual.pdf"
        download
      >
        <img src="../../assets/pcbd3/bd3test/wenjian_pdf.png" alt="" />
        <span>说明书下载</span>
      </a>
    </div>
  </div>
</template>

<script>
import bgIntro from '@/components/common/product/bgIntro.vue';
import product from '@/components/common/bd3/product.vue';
export default {
  name: 'bd3test',
  data() {
    return {
      bg: require('../../assets/pcbd3/bd3test/语音压缩banner 2.png'),
      productData: [
        {
          id: 1,
          name: '北二数传终端',
          imgSrc: require('../../assets/pcbd3/bd3test/shebei1.png'),
          link: 'http://www.fanxingiot.com/PD06.html',
        },
        {
          id: 2,
          name: '北二车载终端',
          imgSrc: require('../../assets/pcbd3/bd3test/shebei2.png'),
          link: 'http://www.tiandiweitong.com/pd05.html',
        },
        {
          id: 3,
          name: '北二指挥机',
          imgSrc: require('../../assets/pcbd3/bd3test/shebei3.png'),
          link: 'http://www.fanxingiot.com/PD08.html',
        },
        {
          id: 4,
          name: '北三数传终端',
          imgSrc: require('../../assets/pcbd3/bd3test/shebei4.png'),
          link: 'http://www.fanxingiot.com/PD19.html',
        },
        {
          id: 5,
          name: '北三车载终端',
          imgSrc: require('../../assets/pcbd3/bd3test/shebei5.png'),
          link: 'http://www.tiandiweitong.com/pd22.html',
        },
        {
          id: 6,
          name: '北三指挥机',
          imgSrc: require('../../assets/pcbd3/bd3test/shebei6.png'),
          link: 'http://www.fanxingiot.com/PD23.html',
        },
      ],
      introData: [
        {
          id: 1,
          introImg: require('../../assets/pcbd3/bd3test/gnjs1.png'),
          iconImg: require('../../assets/pcbd3/bd3test/gnjs_icon_1.png'),
          title: '连接设备 - 串口连接',
          introContent: [
            '①. 设备通过串口线连接到电脑，打开测试软件，点击软件左上角【设备未连接】;',
            '②. 打开设备连接窗口，设置连接方式、串口号、波特率（注：连接方式 -- 串口，串口号 -- 设备连接后串口号，波特率 -- 默认115200，根据实际波特率选择）;',
            '③. 完成选择后点击【打开】，完成设备串口连接。',
          ],
        },
        {
          id: 2,
          introImg: require('../../assets/pcbd3/bd3test/gnjs2.png'),
          iconImg: require('../../assets/pcbd3/bd3test/gnjs_icon_2.png'),
          title: '设备信息 - 设备发信准备',
          introContent: [
            '①. 查询之前，把北斗设备放置开阔地，并将设备朝南摆放，远方无遮挡；',
            '②. 摆放后点击【IC查询】查询设备北斗卡基本信息；',
            '③. 再点击【功率查询】查询通信功率；',
            '④. 当卡号、频度都有，且功率信息至少有一个4，满足北斗通信条件，可进行发信。',
          ],
        },
        {
          id: 3,
          introImg: require('../../assets/pcbd3/bd3test/gnjs3.png'),
          iconImg: require('../../assets/pcbd3/bd3test/gnjs_icon_3.png'),
          title: '发信（北斗通信）',
          introContent: [
            '①. 完成目标地址(北斗卡号)、通信模式(默认选用混合模式)、通信内容填写及勾选后；',
            '②. 点击【通信申请】完成发信操作。',
            '模式1 -- 自收发：目标地址(北斗卡号) 填写设备自身北斗卡号(左边基本信息-卡号) ；',
            '模式2 -- 终端通信：目标地址(北斗卡号) 填写对方设备北斗卡号，其他不变。',
          ],
        },
        {
          id: 4,
          introImg: require('../../assets/pcbd3/bd3test/gnjs4.png'),
          iconImg: require('../../assets/pcbd3/bd3test/gnjs_icon_4.png'),
          title: '关闭RNSS定位',
          introContent: [
            '隐藏RNSS输出（非关闭）；',
            '勾选RNSS按钮查看串口输出的RNSS定位信息；',
            '去掉勾选则隐藏串口输出RNSS定位信息（注：并非永久关闭）',
          ],
        },
        {
          id: 5,
          introImg: require('../../assets/pcbd3/bd3test/gnjs5.png'),
          iconImg: require('../../assets/pcbd3/bd3test/gnjs_icon_5.png'),
          title: '关闭RNSS输出（永久关闭，发指令）',
          introContent: [
            '隐藏RNSS输出（非关闭）；',
            '勾选RNSS按钮查看串口输出的RNSS定位信息；',
            '去掉勾选则隐藏串口输出RNSS定位信息（注：并非永久关闭）',
          ],
        },
        {
          id: 6,
          introImg: require('../../assets/pcbd3/bd3test/gnjs6.png'),
          iconImg: require('../../assets/pcbd3/bd3test/gnjs_icon_6.png'),
          title: 'RNSS',
          introContent: [
            '①. RNSS为无源定位，设备主动搜索北斗广播的定位信息，不会浪费频度，测试软件的【RNSS信息】界面显示北斗设备的定位信息、RNSS定位频度输出设置及设备搜索到的卫星数量、信号强弱；',
            '勾选RNSS按钮查看串口输出的RNSS定位信息；',
            '②. RNSS频度设置范围为0-9，1-9指代间隔(秒)，0为关闭当前RNSS定位输出，默认开启状态。',
          ],
        },
        {
          id: 7,
          introImg: require('../../assets/pcbd3/bd3test/gnjs7.png'),
          iconImg: require('../../assets/pcbd3/bd3test/gnjs_icon_7.png'),
          title: '透传调试',
          introContent: [
            '①. 【透传调试】是通过串口发送指令调试设备，包含串口数据接受区、指令发送记录、指令填写区、常用指令集、历史指令等功能集合；',
            '②. 常用指令集包含RNSS定位开关、修改波特率、保存flash等常用指令集，其他指令可查询北斗相关协议文档自行编辑。',
          ],
        },
      ],
    };
  },
  components: {
    bgIntro,
    product,
  },
};
</script>

<style lang="scss" scoped>
.bd3test {
  width: 100%;
  .intro-section {
    width: 100%;
    background-color: #f6f7f8;
    padding: 40px 0px;
    h3 {
      font-size: 32px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #0d0e24;
      line-height: 30px;
      text-align: center;
      margin-bottom: 45px;
    }
    p {
      margin-top: 12px;
      font-size: 16px;
      font-weight: 400;
      color: #0d0e24;
      line-height: 32px;
    }
  }
  .doc-section {
    padding: 70px 0px;
    h3 {
      text-align: center;
      margin-bottom: 50px;
    }
    .doc-item {
      margin-top: 20px;
      .right-item {
        h4 {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #0d0e24;
        }
        p {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 300;
          color: #666666;
          margin-top: 12px;
          line-height: 30px;
        }
      }
    }
  }

  .download-section {
    // margin: 30px 0px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding-bottom: 70px;
    .item {
      display: inline-block;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      cursor: pointer;
      text-decoration: none;
      span {
        display: inline-block;
        white-space: nowrap;
        font-size: 20px;
        font-weight: 400;
        color: #db251f;
        line-height: 45px;
      }
    }
  }
}

.right90 {
  margin-right: 90px;
}
.reverse {
  flex-direction: row-reverse;
}
</style>